import { createContext } from 'react';
var FormContext = createContext(undefined);
export var FormContextProvider = FormContext.Provider;
export var FormContextConsumer = FormContext.Consumer;
export default FormContext;
